<template>
    <nav-bar :back="goBack"  title="完善拓展客户信息" />
    <div class="popup-content">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="完善客户社会信用代码后，待拓展客户才能成为存量客户！"
      />
      <van-form @submit="handleSubmit">
        <van-field
          name="name"
          v-model="list.companyName"
          label="客户名："
          readonly
          placeholder="请输入客户姓名或单位名称"
          :rules="[{ required: true, message: '此项为必填项' }]"
        />
        <van-field
          name="code"
          v-model="list.creditNo"
          label="客户代码："
          type="text"
          placeholder="企业统一社会信用代码或个体户注册号等"
        />
        <van-field
          name="name"
          readonly
          v-model="list.userName"
          label="联系人"
          placeholder="联系人"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          name="tel"
          readonly
          v-model="list.phoneNum"
          label="联系电话"
          placeholder="联系电话"
          :rules="[{ required: true, message: '请填写电话' }]"
        />
        <van-field
          readonly
          type="textarea"
          name="address"
          v-model="list.address"
          label="地址："
          placeholder="请输入"
          :rules="[{ required: true, message: '此项为必填项' }]"
        />
        <van-field
          name="name"
          readonly
          v-model="list.oldSupply"
          label="原供应商"
          placeholder="原供应商"
        />
        <van-field name="illegalWeight" v-model="list.illegalWeight" type="number" label="日违法用量" />
        <van-field
          type="textarea"
          name="reason"
          readonly
          v-model="list.reason"
          label="拓展原因："
          placeholder="请输入"
        />
        <van-field name="uploader" label="合同" >
          <template #input>
            <van-uploader max-count="1" v-model="fileList" :after-read="afterRead" :before-delete="beforeDelete"  />
          </template>
        </van-field>
        <SelectPoint @get-value="selectPoint" :point="[list.latitude, list.longitude]" />
        <div class="btn-container">
          <van-button block type="primary" :loading="loading" loading-text="请稍后..." :disabled="loading" native-type="submit">
            确认修改
          </van-button>
        </div>
      </van-form>
    </div>
</template>

<script>
import { reactive, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useSubmit, loading } from '@/hooks/useSubmit'
import { updateCustomer, getCustomDetail } from '@/api/customer'
import SelectPoint from './SelectPoint.vue'
import getImgFile from '@/utils/getImgFile'

export default {
  name: 'ModCustomer', // 修改客户
  components: { SelectPoint },
  props: ['userId'],
  setup (props) {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const departId = computed(() => store.state.roleInfo.departId)
    const handleSubmit = () => {
      const params = {
        userId: props.userId,
        creditNo: list.value.creditNo,
        imgPath: imgPath.value,
        illegalWeight: list.value.illegalWeight,
        longitude: formData.longitude,
        latitude: formData.latitude
      }
      const { onSubmit } = useSubmit(updateCustomer, params, () => {
        router.back()
      })
      onSubmit()
    }
    const goBack = () => {
      router.push('/salesUserHome')
    }
    const formData = reactive({
      longitude: 0.0,
      latitude: 0.0
    })
    // 选择位置
    const point = ref('') // 位置
    const selectPoint = (value) => {
      point.value = value
      formData.longitude = value[1]
      formData.latitude = value[0]
    }
    // 文件上传
    const fileList = ref([])
    const imgPath = ref('')
    const afterRead = (file) => {
      getImgFile(file, fileList)
    }
    const beforeDelete = () => {
      fileList.value = []
      imgPath.value = ''
    }
    const list = ref([])
    const router = useRouter()
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCustomDetail, (data) => {
      list.value = data
      if (data && data.imgPath) {
        fileList.value.push({ url: data.imgPath })
      }
    }, props.userId)
    getDataLoading()
    return { handleSubmit, showLoading, isLoading, departId, companyId, goBack, loading, list, fileList, afterRead, beforeDelete, selectPoint, formData }
  }
}
</script>

<style lang="scss" scoped>
  .btn-container {
    margin: 16px;
  }
</style>
